export type MediaType = "video" | "audio" | "text";

export const detectMediaType = (videoUrl?: string | null, audioUrl?: string | null): MediaType => {
  if (videoUrl) return "video";
  if (audioUrl) return "audio";
  return "text";
};

export const getYouTubeId = (url: string): string | null => {
  const match = url.match(
    /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
  );
  return match ? match[1] : null;
};

export const getVimeoId = (url: string): string | null => {
  const match = url.match(/vimeo\.com\/(\d+)/);
  return match ? match[1] : null;
};

export const getYouTubeThumbnail = (url: string): string | null => {
  const id = getYouTubeId(url);
  return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : null;
};

export const isYouTubeUrl = (url: string): boolean => !!getYouTubeId(url);
export const isVimeoUrl = (url: string): boolean => !!getVimeoId(url);

export const isSpotifyUrl = (url: string): boolean =>
  /open\.spotify\.com/.test(url);

export const isSoundCloudUrl = (url: string): boolean =>
  /soundcloud\.com/.test(url);

export const getSpotifyEmbedUrl = (url: string): string | null => {
  const match = url.match(/open\.spotify\.com\/(episode|track|playlist|show|podcast)\/([a-zA-Z0-9]+)/);
  if (!match) return null;
  return `https://open.spotify.com/embed/${match[1]}/${match[2]}`;
};

export const slugify = (text: string): string =>
  text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
